// Payroll engines export - all country-specific implementations

// Import engines and register them explicitly
import { SlovakPayrollEngine } from './SlovakPayrollEngine';
import { GermanPayrollEngine } from './GermanPayrollEngine';
import { AustrianPayrollEngine } from './AustrianPayrollEngine';
import { FrenchPayrollEngine } from './FrenchPayrollEngine';
import { registerPayrollEngine } from '../core/PayrollEngineFactory';

// Register all engines explicitly
registerPayrollEngine('SK', SlovakPayrollEngine);
registerPayrollEngine('DE', GermanPayrollEngine);
registerPayrollEngine('AT', AustrianPayrollEngine);
registerPayrollEngine('FR', FrenchPayrollEngine);

// Export engines for explicit use
export { SlovakPayrollEngine } from './SlovakPayrollEngine';
export { GermanPayrollEngine } from './GermanPayrollEngine';
export { AustrianPayrollEngine } from './AustrianPayrollEngine';
export { FrenchPayrollEngine } from './FrenchPayrollEngine';

// Export core functionality
export * from '../core';

/**
 * Explicitly registered engines
 */
export const REGISTERED_ENGINES = {
  SK: SlovakPayrollEngine,
  DE: GermanPayrollEngine,
  AT: AustrianPayrollEngine,
  FR: FrenchPayrollEngine
};

/**
 * Get information about all available engines
 */
export function getAvailableEngines(): Record<string, any> {
  return {
    SK: {
      name: 'Slovak Payroll Engine',
      description: 'Comprehensive Slovak payroll compliance with TPP, DoVP, DoPČ, DoBPŠ contract types',
      currency: 'EUR',
      contractTypes: ['TPP', 'HALF_TIME', 'DoVP', 'DoPČ', 'DoBPŠ'],
      features: ['Progressive taxation', 'Social insurance', 'Health insurance', 'Child tax bonus', 'Student/pensioner exemptions']
    },
    DE: {
      name: 'German Payroll Engine',
      description: 'German payroll compliance with Minijob, Midijob, and standard employment',
      currency: 'EUR', 
      contractTypes: ['VOLLZEIT', 'TEILZEIT', 'MINIJOB', 'MIDIJOB'],
      features: ['Progressive taxation', 'Social insurance', 'Health insurance', 'Church tax', 'Solidarity surcharge', 'Care insurance']
    },
    AT: {
      name: 'Austrian Payroll Engine',
      description: 'Austrian payroll compliance with comprehensive social insurance and 13th/14th salary support',
      currency: 'EUR',
      contractTypes: ['VOLLZEIT', 'TEILZEIT', 'GERINGFÜGIG', 'BEFRISTET'],
      features: ['Progressive taxation', 'Social insurance', 'Health insurance', '13th/14th salary', 'Chamber fees', 'Special payments']
    },
    FR: {
      name: 'French Payroll Engine',
      description: 'French payroll compliance with CSG/CRDS, complex social security, and 35-hour work week',
      currency: 'EUR',
      contractTypes: ['CDI', 'CDD', 'STAGE', 'APPRENTI', 'INTERIM'],
      features: ['Progressive taxation', 'Social security', 'CSG/CRDS', 'Overtime calculations', 'Meal vouchers', 'Transport subsidies']
    }
  };
}

/**
 * Validation helper to check if a country is supported
 */
export function isCountrySupported(countryCode: string): boolean {
  return countryCode.toUpperCase() in REGISTERED_ENGINES;
}

/**
 * Get supported countries
 */
export function getSupportedCountries(): string[] {
  return Object.keys(REGISTERED_ENGINES);
}